import { monotonicFactory } from 'ulid'

const ulid = monotonicFactory()

/**
 * {@link https://github.com/ulid/ulid}
 */
export const generateRandomId = (timestamp: number = Date.now()) => {
  return ulid(timestamp)
}
